// import images
import Logo from "../src/img/header/logo.svg";
import GalleryImg1 from "../src/img/gallery/1.png";
import GalleryImg2 from "../src/img/gallery/2.png";
import GalleryImg3 from "../src/img/gallery/3.png";
import GalleryImg4 from "../src/img/gallery/4.png";
import GalleryImg5 from "../src/img/gallery/5.png";
import GalleryImg6 from "../src/img/gallery/6.png";
import GalleryImg7 from "../src/img/gallery/7.png";
import GalleryImg8 from "../src/img/gallery/8.png";
// import icons
import { GrFacebookOption } from "react-icons/gr";
import { IoMdArrowForward } from "react-icons/io";
import { FiSend } from "react-icons/fi";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram, FaLinkedin, FaYoutube, FaTiktok } from "react-icons/fa";
import {
  IoLogoInstagram,
  IoLogoPinterest,
  IoLogoTwitter,
  IoLogoYoutube,
} from "react-icons/io";

// NAVBAR & HEADER SECTION
export const headerData = {
  logo: Logo,
};

export const navData = {
  items: [
    { href: "/", name: "Home" },
    { href: "/about", name: "About" },
    { href: "/gallery", name: "Gallery" },
    { href: "/contact", name: "Contact" },
  ],
};

export const socialData = [
  { href: "https://facebook.com/", icon: <GrFacebookOption /> },
  { href: "https://www.instagram.com/ernesto.moras/", icon: <IoLogoInstagram /> },
  { href: "https://pinterest.com/", icon: <IoLogoPinterest /> },
  { href: "https://twitter.com/", icon: <IoLogoTwitter /> },
  { href: "https://youtube.com", icon: <IoLogoYoutube /> },
];
// NAVBAR & HEADER SECTION END
////////////////////////////////////
// HERO SECTION
// HERO SECTION END
///////////////////////////////////
// ABOUT SECTION
// ABOUT SECTION END
/////////////////////////////////////////////////
// GALLERY SECTION
export const galleryData = {
  title: "Gallery",
  btnText: "View all",
  href: "/gallery",
  btnIcon: <IoMdArrowForward />,
  images: [
    { src: GalleryImg1, original: GalleryImg1, width: 465, height: 412 },
    { src: GalleryImg2, original: GalleryImg2, width: 465, height: 540 },
    { src: GalleryImg3, original: GalleryImg3, width: 465, height: 412 },
    { src: GalleryImg4, original: GalleryImg4, width: 465, height: 540 },
    { src: GalleryImg5, original: GalleryImg5, width: 465, height: 540 },
    { src: GalleryImg6, original: GalleryImg6, width: 464, height: 412 },
    { src: GalleryImg7, original: GalleryImg7, width: 465, height: 540 },
    { src: GalleryImg8, original: GalleryImg8, width: 465, height: 412 },
  ],
};
// GALLERY SECTION END
////////////////////////////////////////////////////////////////
// CONTACT SECTION
export const contactData = {
  title: "Get in touch with us",
  info: [
    {
      title: "Ankara Studio",
      subtitle:
        "In velit arcu posuere integer sit amet, consectetur nun adipiscing elit. Duis porttitor massa tellus",
      address: {
        icon: <FaMapMarkerAlt />,
        name: "784.Cd 145.Sk 4/A 06200, Çankaya, Ankara",
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: "+90 (555) 555 55-55",
      },
      email: {
        icon: <FaEnvelope />,
        address: "contact@yourcompany.com",
      },
      link: "Get location",
    },
  ],
  form: {
    name: "Your name",
    email: "Your email address",
    message: "Your messages",
    btnText: "Send",
  },
};
// CONTACT SECTION END
////////////////////////////////////////////////////////////////////////
// FOOTER SECTION (mejorado SEO + accesibilidad)
export const footerData = {
  about: {
    title: "Sobre mí",
    subtitle:
      "IA aplicada en SST para líderes HSE: inspiro y empodero a equipos para elevar los estándares de prevención y bienestar.",
    address: {
      icon: <FaMapMarkerAlt aria-hidden="true" />,
      name: "7027 W Broward Blvd #708, Plantation, FL 33324",
      href: "https://maps.google.com/?q=7027+W+Broward+Blvd+%23708,+Plantation,+FL+33324",
      ariaLabel: "Abrir dirección en Google Maps",
    },
    phone: {
      icon: <FaPhoneAlt aria-hidden="true" />,
      display: "+1 (954) 665 0480",
      href: "tel:+19546650480",
      ariaLabel: "Llamar al teléfono de contacto",
    },
    email: {
      icon: <FaEnvelope aria-hidden="true" />,
      address: "contactos@ernestomora.com",
      href: "mailto:contactos@ernestomora.com",
      ariaLabel: "Enviar correo a contactos@ernestomora.com",
    },
  },
  links: {
    title: "Secciones",
    items: [
      { href: "/about", name: "Sobre Nosotros", ariaLabel: "Ir a Sobre Nosotros" },
      { href: "/Interactive3DSection", name: "Redes Sociales", ariaLabel: "Ir a Redes Sociales" },
      { href: "/ContratarSection", name: "Contactar", ariaLabel: "Ir a Contactar" },
      { href: "/blogernesto", name: "Blog", ariaLabel: "Ir al Blog de Ernesto" },
      { href: "/faq-ia-sst", name: "FAQ IA en SST", ariaLabel: "Ir a Preguntas Frecuentes" },
    ],
  },
  program: {
    title: "Horario de trabajo",
    items: [{ name: "Lunes a Viernes / 09:00–17:00", ariaLabel: "Horario de lunes a viernes, nueve a cinco" }],
  },
  newsletter: {
    title: "Newsletter",
    subtitle: "Suscríbete para recibir estrategias de IA aplicada en SST.",
    form: {
      placeholder: "Tu correo electrónico",
      icon: <FiSend aria-hidden="true" />,
      ariaLabel: "Suscribirse al newsletter",
      privacyNote: "Al suscribirte aceptas nuestra Política de Privacidad.",
      privacyHref: "/privacidad",
    },
  },
  // Bloque de redes en footer
  social: {
    title: "Sígueme",
    items: [
      { name: "Instagram", href: "https://www.instagram.com/ernesto.moras/", icon: <FaInstagram aria-hidden="true" />, ariaLabel: "Abrir Instagram de Ernesto Mora" },
      { name: "LinkedIn", href: "https://www.linkedin.com/in/ernestomorasoto/", icon: <FaLinkedin aria-hidden="true" />, ariaLabel: "Abrir LinkedIn de Ernesto Mora" },
      { name: "YouTube", href: "https://youtube.com", icon: <FaYoutube aria-hidden="true" />, ariaLabel: "Abrir YouTube de Ernesto Mora" },
      { name: "TikTok", href: "https://www.tiktok.com/@businesstipsbyernesto", icon: <FaTiktok aria-hidden="true" />, ariaLabel: "Abrir TikTok de Ernesto Mora" },
    ],
  },
  // Bloque legal
  legal: {
    title: "Legal",
    items: [
      { href: "/privacidad", name: "Política de Privacidad", ariaLabel: "Ver Política de Privacidad" },
      { href: "/terminos", name: "Términos y Condiciones", ariaLabel: "Ver Términos y Condiciones" },
      { href: "/sitemap.xml", name: "Sitemap", ariaLabel: "Ver Sitemap XML" },
    ],
  },
};
// FOOTER SECTION END

// JSON-LD para Helmet (mejora SEO de marca + datos de contacto)
export const footerJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Ernesto Mora",
  "url": "https://ernestomora.com/",
  "email": "mailto:contactos@ernestomora.com",
  "telephone": "+19546650480",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "7027 W Broward Blvd #708",
    "addressLocality": "Plantation",
    "addressRegion": "FL",
    "postalCode": "33324",
    "addressCountry": "US"
  },
  "sameAs": [
    "https://www.instagram.com/ernesto.moras/",
    "https://www.linkedin.com/in/ernestomorasoto/",
    "https://youtube.com",
    "https://www.tiktok.com/@businesstipsbyernesto"
  ]
};

/*
Uso recomendado del JSON-LD en tu layout/footer:
import { Helmet } from "react-helmet-async";
import { footerJsonLd } from "RUTA/este/archivo";

<Helmet>
  <script type="application/ld+json">{JSON.stringify(footerJsonLd)}</script>
</Helmet>
*/
